<script lang="ts" setup>
/*=============================================================================*/
/*                               Imports                                       */
/*=============================================================================*/
import { useIrveStore } from "@modules/irve/stores/irve.store"
import { formatIdSource } from "@core/helpers"
import { useI18n } from "vue-i18n"
import { computed, onBeforeMount } from "vue"
const irveStore = useIrveStore()
/*=============================================================================*/
/*                                  Props                                      */
/*=============================================================================*/

/*=============================================================================*/
/*                                  Lang                                       */
/*=============================================================================*/
const { t } = useI18n({
    messages: {
        fr: {
            simulation: "Simulation électrique de l'installation",
            consommation: "Consommation totale sur le PDL {meterId}",
        },
    },
})

const getGraphSimulation = computed(() => {
    return [
        {
            graph_id: "puissanceactive_elec",
            name: "Puissance",
            unit: "kVA",
            graph: irveStore.getCurrentAnalysis?.outputs?.graphs
                ?.puissanceactive_elec,
        },
    ]
})

const getGraphConsommation = computed(() => {
    return [
        {
            graph_id: "consommation_totale",
            name: "Consommation totale",
            unit: "kWh",
            graph: irveStore.getCurrentAnalysis?.outputs?.graphs
                ?.energieactive_elec,
        },
    ]
})

onBeforeMount(() => {
    if (!irveStore.currentAnalysisId) {
        irveStore.fetchCurrentAnalysis.fetch()
    }
})
</script>

<template>
    <BaseCard
        class="irve-view border p-6 [--p-card-body-padding:0] [--p-card-shadow:none]"
    >
        <template #header>
            <div class="border-b border-slate-200 pb-6">
                <IrveViewHeader></IrveViewHeader>
            </div>
        </template>
        <template #content>
            <div class="flex flex-col gap-6 pt-6">
                <IrveViewIndicators />
                <hr />
                <div>
                    <IrveViewDataChart
                        :title="t('simulation')"
                        :graphs="getGraphSimulation"
                    >
                    </IrveViewDataChart>
                </div>
                <hr />
                <div>
                    <IrveViewDataChart
                        :title="
                            t('consommation', {
                                meterId: formatIdSource(
                                    irveStore.getCurrentAnalyseMeter?.idsource!,
                                    'pdl'
                                ),
                            })
                        "
                        :graphs="getGraphConsommation"
                    >
                    </IrveViewDataChart>
                </div>
            </div>
        </template>
    </BaseCard>
</template>
